<template>
  <div class="sidebar-overlay" @click="closeSidebar"></div>
</template>

<script>
export default {
  methods: {
    closeSidebar() {
      this.$store.commit('setSidebarState', false);
    }
  }
};
</script>

<style lang="scss" scoded>
@import '@/assets/styles/vars';
.sidebar-overlay {
  background-color: rgba($dark, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: 5;
  //   display: none;

  &.opened {
    display: block;
  }
}
</style>
